import { render, staticRenderFns } from "./gmv-statistics.vue?vue&type=template&id=8169191e&scoped=true"
import script from "./gmv-statistics.vue?vue&type=script&lang=js"
export * from "./gmv-statistics.vue?vue&type=script&lang=js"
import style0 from "./gmv-statistics.vue?vue&type=style&index=0&id=8169191e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8169191e",
  null
  
)

export default component.exports